import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import type { JSX } from 'react';
export const HEADER_TITLE_DEFAULT_ID = 'header-title';
export type HeaderTitleProps = {
  display?: 'flex' | 'block' | 'inline' | 'inline-flex' | 'grid';
  flexDirection?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  gap?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  icon?: Icon;
  marginBottom?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  marginTop?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  subtitle?: string | JSX.Element;
  title: string | JSX.Element;
  titleElementId?: string;
  zIndex?: number | string;
};
const HeaderTitle = t0 => {
  const $ = _c(28);
  const {
    display,
    flexDirection,
    gap: t1,
    icon: Icon,
    marginTop: t2,
    marginBottom: t3,
    subtitle,
    title,
    titleElementId: t4,
    zIndex
  } = t0;
  const gap = t1 === undefined ? 3 : t1;
  const marginTop = t2 === undefined ? 0 : t2;
  const marginBottom = t3 === undefined ? 0 : t3;
  const titleElementId = t4 === undefined ? HEADER_TITLE_DEFAULT_ID : t4;
  const gapClass = gap !== undefined ? `gap-${gap === 3 ? 2 : gap === 5 ? 4 : gap === 7 ? 6 : gap === 4 ? 3 : gap === 6 ? 5 : gap === 8 ? 8 : gap === 1 ? 0.5 : gap === 2 ? 1 : gap}` : "";
  const mtClass = marginTop !== undefined && marginTop !== 0 ? `mt-${marginTop === 3 ? 2 : marginTop === 5 ? 4 : marginTop === 7 ? 6 : marginTop === 4 ? 3 : marginTop === 6 ? 5 : marginTop === 8 ? 8 : marginTop === 1 ? 0.5 : marginTop === 2 ? 1 : marginTop}` : "";
  const mbClass = marginBottom !== undefined && marginBottom !== 0 ? `mb-${marginBottom === 3 ? 2 : marginBottom === 5 ? 4 : marginBottom === 7 ? 6 : marginBottom === 4 ? 3 : marginBottom === 6 ? 5 : marginBottom === 8 ? 8 : marginBottom === 1 ? 0.5 : marginBottom === 2 ? 1 : marginBottom}` : "";
  const t5 = display === "block" && "block";
  const t6 = display === "inline" && "inline";
  const t7 = display === "inline-flex" && "inline-flex";
  const t8 = display === "grid" && "grid";
  const t9 = flexDirection === "row" && "flex-row";
  const t10 = flexDirection === "row-reverse" && "flex-row-reverse";
  const t11 = flexDirection === "column-reverse" && "flex-col-reverse";
  let t12;
  if ($[0] !== gapClass || $[1] !== mbClass || $[2] !== mtClass || $[3] !== t10 || $[4] !== t11 || $[5] !== t5 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
    t12 = cx("flex items-center flex-col text-center", gapClass, mtClass, mbClass, t5, t6, t7, t8, t9, t10, t11);
    $[0] = gapClass;
    $[1] = mbClass;
    $[2] = mtClass;
    $[3] = t10;
    $[4] = t11;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] !== zIndex) {
    t13 = {
      zIndex
    };
    $[11] = zIndex;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] !== Icon) {
    t14 = Icon && <Icon color="primary" />;
    $[13] = Icon;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== title || $[16] !== titleElementId) {
    t15 = <h2 id={titleElementId} className="text-heading-3 text-primary fp-text fp-custom-appearance fp-page-header-title">{title}</h2>;
    $[15] = title;
    $[16] = titleElementId;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== subtitle) {
    t16 = subtitle && <h3 className="text-body-2 text-secondary fp-text fp-custom-appearance fp-page-header-subtitle">{subtitle}</h3>;
    $[18] = subtitle;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t15 || $[21] !== t16) {
    t17 = <div className="fp-custom-appearance fp-page-header flex flex-col items-center gap-2">{t15}{t16}</div>;
    $[20] = t15;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== t12 || $[24] !== t13 || $[25] !== t14 || $[26] !== t17) {
    t18 = <div className={t12} style={t13}>{t14}{t17}</div>;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  return t18;
};
export default HeaderTitle;